var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5612 22.6327H5.2551C2.35744 22.6327 0 20.5372 0 17.9615V4.88211C0 2.30641 2.35744 0.210907 5.2551 0.210907H11.5612C14.4589 0.210907 16.8163 2.30641 16.8163 4.88211V17.9615C16.8163 20.5372 14.4589 22.6327 11.5612 22.6327ZM5.2551 2.07939C3.51671 2.07939 2.10204 3.33688 2.10204 4.88211V17.9615C2.10204 19.5067 3.51671 20.7642 5.2551 20.7642H11.5612C13.2996 20.7642 14.7143 19.5067 14.7143 17.9615V4.88211C14.7143 3.33688 13.2996 2.07939 11.5612 2.07939H5.2551ZM10.5102 17.9615C10.5102 17.4458 10.0393 17.0272 9.45918 17.0272H7.35714C6.77698 17.0272 6.30612 17.4458 6.30612 17.9615C6.30612 18.4772 6.77698 18.8957 7.35714 18.8957H9.45918C10.0393 18.8957 10.5102 18.4772 10.5102 17.9615Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconWhite);
export default __webpack_public_path__ + "static/media/phone_icon_white.b1971dde41d8e685f2e0a0cab56d8b83.svg";
export { ForwardRef as ReactComponent };